#import "../fragments/transaction.fragment.graphql"

query getPurchaseTransaction($start_date: String, $limit: Int, $offset: Int, $order: JSON) {
    getPurchaseTransaction(start_date: $start_date, limit: $limit, offset: $offset, order: $order) {
        ...TransactionFragment
    }
}
